import cc from 'classcat';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import AlertMessage from '../AlertMessage';
import Button from '../Button';
import AddToCalendar from '../AddToCalendar';
import ClickToCopy from '../ClickToCopy';
import css from './index.module.scss';

class AlertRSVP extends PureComponent {
  onGetDirections = (event) => {
    event.preventDefault();
    const { mapsURL } = this.props;
    window.open(mapsURL);
  };

  getSubmittedNode = () => {
    const { date, waitlisted } = this.props;
    const { gcalUrl, id } = date;

    if (waitlisted) {
      const links = [
        <Button route="/">Find More Events</Button>,
        <ClickToCopy gray url={window.location.toString()}>
          Copy Event Link
        </ClickToCopy>,
      ];
      return (
        <AlertMessage title="Added To Waitlist" subtitle="We'll send you an email if a spot opens up." links={links} />
      );
    }

    return (
      <>
        <h2 className={css.title}>You&rsquo;re On The List</h2>
        <p className={css.details}>A confirmation email has been sent to your email.</p>
        <ul className={css.links}>
          <li className={css.link}>
            <AddToCalendar gcalUrl={gcalUrl} id={id}>
              Add To Calendar
            </AddToCalendar>
          </li>
          <li className={css.link}>
            <Button gray onClick={this.onGetDirections} aria-label="Get Directions">
              Get Directions
            </Button>
          </li>
          <li className={css.link}>
            <ClickToCopy gray url={window.location.toString()}>
              Copy Event Link
            </ClickToCopy>
          </li>
        </ul>
      </>
    );
  };

  render() {
    return <div className={cc([css.success, css.successSubmitted])}>{this.getSubmittedNode()}</div>;
  }
}

AlertRSVP.defaultProps = {
  waitlisted: false,
};

AlertRSVP.propTypes = {
  date: PropTypes.shape().isRequired,
  mapsURL: PropTypes.string.isRequired,
  waitlisted: PropTypes.bool,
};

export default AlertRSVP;
